/**
 * @fileoverview Read-only system milestone display component
 */

import { CheckCircle2, Circle } from 'lucide-react';
import { Milestone } from '@/lib/types/milestone';
import { format } from 'date-fns';

interface SystemMilestoneItemProps {
  milestone: Milestone;
}

export function SystemMilestoneItem({ milestone }: SystemMilestoneItemProps) {
  const isCompleted = milestone.is_completed;

  return (
    <div className="flex items-start gap-3 py-2">
      {isCompleted ? (
        <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
      ) : (
        <Circle className="h-5 w-5 text-muted-foreground mt-0.5 flex-shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <p className={`font-medium ${isCompleted ? 'text-foreground' : 'text-muted-foreground'}`}>
            {milestone.milestone_name}
          </p>
          {isCompleted && milestone.completed_at && (
            <span className="text-xs text-muted-foreground whitespace-nowrap">
              {format(new Date(milestone.completed_at), 'MMM d, yyyy')}
            </span>
          )}
        </div>
        <p className="text-sm text-muted-foreground mt-0.5">
          {milestone.deliverable}
        </p>
      </div>
    </div>
  );
}
